module.exports = __webpack_public_path__ + "media/images/common/3column_product_bg_yny-cd887f206edb26ed0cb6f7e62fa7a7b1.png";